import { Toggle } from '@silverfort/sf-components';
import { SmartPolicyEntityFullData } from '../../../SmartPoliciesTypes';
import { useSmartPolicyContext } from '../../../SmartPolicyContext';
import ScopeComponent from './ScopeComponent/ScopeComponent';
import { AD_ENTITY_TYPES, ScopeEntity, SCOPES } from './ScopeComponent/ScopeTypes';
import { useEffect, useMemo, useState } from 'react';
import useHasPermissions from '../../../../../../../../hooks/useHasPermissions';
import { Pages, Roles } from '../../../../../../../../context/contexts/UserContext/permissionsTypes';

const OutScope = () => {
    const { smartPolicyForEdit, setSmartPolicyForEdit } = useSmartPolicyContext();
    const isEditor = useHasPermissions({ permission: Pages.SERVICE_ACCOUNTS, role: Roles.EDITOR });
    const [showOutScope, setShowOutScope] = useState(false);

    useEffect(() => {
        if (!smartPolicyForEdit) return;

        const outScopeEntities = smartPolicyForEdit.entities.filter((entity) => entity.excluded);
        if (outScopeEntities.length > 0) {
            setShowOutScope(true);
        }
    }, [smartPolicyForEdit]);

    const outScopeEntities = useMemo(() => {
        return (smartPolicyForEdit?.entities || [])
            .filter((entity) => entity.excluded)
            .map((entity) => ({
                guid: entity.guid,
                display_name: entity.display_name,
                domain_name: entity.domain_name,
                type: entity.type as AD_ENTITY_TYPES
            })) as ScopeEntity[];
    }, [smartPolicyForEdit?.entities]);

    if (!smartPolicyForEdit) {
        return <></>;
    }

    const onToggleOutScope = (value: boolean) => {
        setShowOutScope(value);
        if (!value) {
            const inScopeEntities = smartPolicyForEdit.entities.filter((entity) => !entity.excluded);
            setSmartPolicyForEdit({
                ...smartPolicyForEdit,
                entities: inScopeEntities
            });
        }
    };

    const onChange = (entities: ScopeEntity[]) => {
        const smartPolicyOutScopeEntities: SmartPolicyEntityFullData[] = entities.map((entity) => ({
            guid: entity.guid,
            display_name: entity.display_name,
            domain_name: entity.domain_name,
            type: entity.type,
            excluded: true
        }));
        const inScopeEntities: SmartPolicyEntityFullData[] = smartPolicyForEdit.entities.filter(
            (entity) => !entity.excluded
        );

        setSmartPolicyForEdit({
            ...smartPolicyForEdit,
            entities: [...smartPolicyOutScopeEntities, ...inScopeEntities]
        });
    };

    return (
        <>
            <Toggle checked={showOutScope} onChange={onToggleOutScope} label="Out of Scope" disabled={!isEditor} />
            {showOutScope && (
                <ScopeComponent
                    entities={outScopeEntities}
                    onChange={onChange}
                    scope={SCOPES.OUT_SCOPE}
                    subtitle="Optional"
                    disabled={!isEditor}
                />
            )}
        </>
    );
};

export default OutScope;
